import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/demo/3d/visualization")({
  component: () => <Outlet />,
});
